<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'PmsMain'
  }
</script>

<style scoped>

</style>